<div class="row">
  <nav
    ngbNav
    #nav="ngbNav"
    class="nav-tabs border-bottom tw-text-center"
    [destroyOnHide]="false"
    [activeId]="selectedMode"
    (activeIdChange)="onChangeMode($event)"
  >
    <!-- manual -->
    <ng-container [ngbNavItem]="'manual'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <i class="mdi mdi-keyboard text-navyBlue tw-mr-1 mdi-24px"></i>
        <span class="tw-mt-1 tw-mr-2 tw-text-lg text-dark">{{
          "common.manual" | translate
        }}</span>
      </a>

      <!-- 1 -->
      <ng-template ngbNavContent>
        <div class="row">
          <div class="md:tw-w-full">
            <mat-form-field appearance="outline" class="tw-w-full">
              <!-- label -->
              <mat-label [class.text-xl]="namesCount">
                {{ "common.names" | translate }}
              </mat-label>

              <div class="text-editor">
                <!-- text area -->
                <textarea
                  class="font-vazir-ui"
                  [(ngModel)]="names"
                  matInput
                  [readonly]="pastedLoading"
                  autocomplete="off"
                  [rows]="5"
                  (keydown)="checkInputText($event)"
                  (change)="checkInputText($event)"
                  (paste)="checkPastedText($event)"
                ></textarea>
                <div
                  class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
                >
                  <!-- download -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.downloadFile' | translate"
                      *ngIf="namesFile"
                      [href]="namesFile"
                      download="Names.txt"
                    >
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>
                  </div>

                  <!-- eraser -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.clear' | translate"
                      *ngIf="names; else disableEraser"
                      (click)="clearNames()"
                    >
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                    <ng-template #disableEraser>
                      <a class="disable">
                        <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- copy -->
                  <div class="tw-mb-2 tw-mt-1">
                    <a
                      [matTooltip]="'common.copy' | translate"
                      *ngIf="names; else disableCopy"
                      (click)="copyToClipboard(names)"
                    >
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                    <ng-template #disableCopy>
                      <a class="disable">
                        <i
                          class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                        ></i>
                      </a>
                    </ng-template>
                  </div>
                </div>

                <div class="pasted__loading" *ngIf="pastedLoading">
                  <div
                    class="spinner-border text-primary tw-pb-2"
                    role="status"
                  ></div>
                  <span> {{ "common.loading" | translate }}</span>
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>
      </ng-template>
    </ng-container>

    <!-- clipboard -->
    <ng-container [ngbNavItem]="'clipboard'">
      <a
        ngbNavLink
        class="tw-flex-center border bg-transparent"
        style="flex: 1"
      >
        <i class="mdi mdi-content-paste text-info tw-mr-1 mdi-22px"></i>
        <span class="tw-mt-1 tw-mr-2 tw-text-lg text-dark">{{
          "common.clipBoard" | translate
        }}</span>
      </a>

      <!-- 3 -->
      <ng-template ngbNavContent>
        <div class="row">
          <div class="md:tw-w-full">
            <mat-form-field appearance="outline" class="tw-w-full">
              <!-- label -->
              <mat-label [class.text-xl]="namesCount | numberSeparator">
              </mat-label>

              <div class="text-editor tw-relative">
                <!-- text area -->
                <textarea
                  matInput
                  [readonly]="true"
                  autocomplete="off"
                  [rows]="5"
                  (paste)="checkPastedText($event)"
                  [id]="input_id + '-clipboard-textarea'"
                  class="text-white font-vazir-ui"
                  style="resize: none; overflow: hidden"
                >
                </textarea>

                <span
                  *ngIf="!names && !pastedLoading"
                  class="absolute-center text-gray tw-font-normal tw-text-[14px]"
                  style="line-height: 1.7"
                >
                  <span
                    class="dark:tw-text-gray-200"
                    [innerHTML]="'messages.pasteNames' | translate"
                  ></span>
                </span>
                <div
                  *ngIf="names && !pastedLoading"
                  class="absolute-center text-gray tw-font-medium"
                  style="line-height: 1.5"
                >
                  <div
                    [innerHTML]="
                      'messages.namesRegistered'
                        | translate
                          : {
                              namesCount: namesCount | numberSeparator
                            }
                    "
                  ></div>
                </div>

                <div
                  class="text-editor__buttons tw-border-r tw-border-dashed tw-border-r-slate-300 dark:tw-border-r-slate-700"
                >
                  <!-- paste -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.replace' | translate"
                      (click)="getDataFromClipboard()"
                    >
                      <i
                        class="mdi mdi-clipboard-arrow-down-outline text-navyBlue tw-mt-1"
                      ></i>
                    </a>
                  </div>

                  <!-- download -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.downloadFile' | translate"
                      *ngIf="namesFile"
                      [href]="namesFile"
                      download="Names.txt"
                    >
                      <i class="mdi mdi-tray-arrow-down text-gray"></i>
                    </a>
                  </div>

                  <!-- eraser -->
                  <div class="tw-mb-2">
                    <a
                      [matTooltip]="'common.clear' | translate"
                      *ngIf="namesCount; else disableEraser"
                      (click)="clearNames()"
                    >
                      <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                    </a>
                    <ng-template #disableEraser>
                      <a class="disable">
                        <i class="mdi mdi-eraser text-danger tw-mt-1"></i>
                      </a>
                    </ng-template>
                  </div>

                  <!-- copy -->
                  <div class="tw-mb-2 tw-mt-1">
                    <a
                      [matTooltip]="'common.copy' | translate"
                      *ngIf="names; else disableCopy"
                      (click)="copyToClipboard(names)"
                    >
                      <i
                        class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                      ></i>
                    </a>
                    <ng-template #disableCopy>
                      <a class="disable">
                        <i
                          class="mdi mdi-content-copy mdi-24px text-info tw-mt-1"
                        ></i>
                      </a>
                    </ng-template>
                  </div>
                </div>

                <div class="pasted__loading" *ngIf="pastedLoading">
                  <div
                    class="spinner-border text-primary tw-pb-2"
                    role="status"
                  ></div>
                  <span> {{ "common.loading" | translate }}</span>
                </div>
              </div>
            </mat-form-field>
          </div>
        </div>
      </ng-template>
    </ng-container>
  </nav>
  <div [ngbNavOutlet]="nav" class="tw-mt-2"></div>
</div>

<div class="d-none" [formGroup]="input_form">
  <input
    type="text"
    class="dir-ltr"
    [formControlName]="input_formControlName"
    [(ngModel)]="names"
  />
</div>
